module.exports = __webpack_public_path__ + "static/media/letter-4.e7d05f8c.png";